import { redirectDocument } from 'react-router';
import { isAppUpdateAvailable } from './core';

/**
 * Call at the top of the root route's loader. Once a new frontend version
 * has been detected, the in-flight SPA navigation is escalated to a full
 * document load of the same URL: the tab picks up the new version at a
 * natural boundary (navigation was already discarding page state).
 */
export function appUpdateNavigationGuard(request: Request): void {
    if (isAppUpdateAvailable()) throw redirectDocument(request.url);
}

/**
 * OR into the root route's `shouldRevalidate`: parent loaders don't rerun on
 * child↔child pathname navigations by default, so this forces the loader
 * (and its `appUpdateNavigationGuard`) to run once an update is pending.
 */
export function shouldRevalidateForAppUpdate(): boolean {
    return isAppUpdateAvailable();
}
